import * as React from 'react';
import { Fab, Zoom, Box, Stack, Typography, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Icon } from '@iconify/react';

const fabStyle = {
  position: 'fixed',
  bottom: 24,
  right: 24,
};
export default function AddMenuFab({ SetContentBox, contentBox, hasChats }) {
  const [open, setOpen] = React.useState(false);

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 1400,
      }}
      onMouseLeave={() => setOpen(false)}
    >
      {/* Options */}
      <Stack spacing={1.5} sx={{ mb: 2, alignItems: 'center' }}>
        {contentBox !== 'createChat' && (
          <Zoom in={open}>
            <Tooltip title="New Chat" placement="left" arrow>
              <Fab size="small" color="secondary" onClick={() => SetContentBox('createChat')}>
                <Icon icon="mdi:chat-plus" fontSize={28} />
              </Fab>
            </Tooltip>
          </Zoom>
        )}

        {contentBox !== 'creatGroup' && (
          <Zoom in={open}>
            <Tooltip title="Create a team" placement="left" arrow>
              <Fab size="small" color="secondary" onClick={() => SetContentBox('creatGroup')}>
                <Icon icon="mdi:account-group" fontSize={28} />
              </Fab>
            </Tooltip>
          </Zoom>
        )}
      </Stack>

      {/* Main FAB — ONLY hover trigger */}
      {contentBox !== null ? (
        <Tooltip title="Go Back" placement="left" arrow>
        <Fab
          size="small"
          color="primary"
          onClick={() => {
            SetContentBox(null);
            setOpen(false);
          }}
           sx={{
            background: 'linear-gradient(135deg, #561f6e, #0c3e6b)',
            color: '#fff',
            boxShadow: '0 10px 30px rgba(12,62,107,0.45)',
            m: 0.5,
          }}
        >
          <Icon icon="mdi:arrow-left" fontSize={30} />
        </Fab>
        </Tooltip>
      ) : (
        <Fab
          size="small"
          onMouseEnter={() => setOpen(true)}
          sx={{
            background: 'linear-gradient(135deg, #561f6e, #0c3e6b)',
            color: '#fff',
            // boxShadow: '0 10px 30px rgba(12,62,107,0.45)',
            animation: !hasChats ? 'pulseFloat 2.8s infinite' : 'none',
            '&:hover': {
              transform: 'scale(1.08)',
            },
            m: 0.5,
          }}
        >
          <Icon icon="mdi:plus" fontSize={25} />
        </Fab>
      )}
      <style>
        {`
          @keyframes pulseFloat {
            0% { transform: scale(1) translateY(0); box-shadow: 0 0 0 0 rgba(86,31,110,0.4); }
            50% { transform: scale(1.05) translateY(-3px); }
            70% { box-shadow: 0 0 0 14px rgba(86,31,110,0); }
            100% { transform: scale(1) translateY(0); box-shadow: 0 0 0 0 rgba(86,31,110,0); }
          }

          @keyframes fadeUp {
            0%,100% { opacity: 0.4; transform: translateY(0); }
            50% { opacity: 1; transform: translateY(-4px); }
          }
        `}
      </style>
    </Box>
  );
}
